import { Component } from '@angular/core';
import { ModalComponent } from '../../../../../models/modal-component';
import { ApplicationStateService } from '../../../../../services/application-state.service';

@Component({
    selector: 'app-accessibility-modal',
    templateUrl: './accessibility-modal.component.html',
    styleUrls: ['./accessibility-modal.component.scss'],
    standalone: true
})
export class AccessibilityModalComponent extends ModalComponent {
    static MODAL_ID = 'accessibilityModal';
    modifierKey = (typeof navigator !== 'undefined' && /Mac|iPhone|iPod|iPad/.test(navigator.userAgent)) ? 'Option ⌥' : 'Alt';

    constructor(public applicationStateService: ApplicationStateService) {
        super();
    }

    getId(): string {
        return AccessibilityModalComponent.MODAL_ID;
    }
}
